"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStore = function (store) {
    if (!store) {
        return true;
    }
    if (store.hasOwnProperty('get')) {
        // TODO: Rebuild as dynamic import -> import('store'): Promise<Package>
        // tslint:disable-next-line:no-require-imports
        return require('store');
    }
    return {
        get: function (key) { return store.getItem(key); },
        getItem: function (key) { return Promise.resolve(JSON.parse(store.getItem(key))); },
        removeItem: function (key) { return Promise.resolve(store.removeItem(key)); },
        set: function (key, value) { return store.setItem(key, value); },
        setItem: function (key, value) {
            return Promise.resolve(store.setItem(key, JSON.stringify(value)));
        },
    };
};
